var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedPurchaseRequisition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 10.6666C21.3334 7.74992 18.9167 5.33325 16.0001 5.33325C13.0417 5.33325 10.6667 7.74992 10.6667 10.6666H6.66675V23.3333C6.66675 25.2083 8.12508 26.6666 10.0001 26.6666H22.0001C23.8334 26.6666 25.3334 25.2083 25.3334 23.3333V10.6666H21.3334ZM16.0001 7.33325C17.8334 7.33325 19.3334 8.83325 19.3334 10.6666H12.6667C12.6667 8.83325 14.1251 7.33325 16.0001 7.33325ZM23.3334 23.3333C23.3334 24.0833 22.7084 24.6666 22.0001 24.6666H10.0001C9.25008 24.6666 8.66675 24.0833 8.66675 23.3333V12.6666H10.6667V14.3333C10.6667 14.9166 11.0834 15.3333 11.6667 15.3333C12.2084 15.3333 12.6667 14.9166 12.6667 14.3333V12.6666H19.3334V14.3333C19.3334 14.9166 19.7501 15.3333 20.3334 15.3333C20.8751 15.3333 21.3334 14.9166 21.3334 14.3333V12.6666H23.3334V23.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPurchaseRequisition);
export default __webpack_public_path__ + "static/media/Selected Purchase Requisition.2843373364995028d51094f4d5d7e36e.svg";
export { ForwardRef as ReactComponent };